import api from './api';

const commissionService = {
  /**
   * Get commissions list
   */
  async getCommissions(filters = {}, options = {}) {
    const params = {
      ...filters,
      page: options.page || 1,
      limit: options.limit || 20
    };
    const response = await api.get('/partners/commissions', { params });
    return response.data;
  },

  /**
   * Get commission summary
   */
  async getSummary(year) {
    const params = year ? { year } : {};
    const response = await api.get('/partners/commissions/summary', { params });
    return response.data;
  },

  /**
   * Get payouts list
   */
  async getPayouts(filters = {}, options = {}) {
    const params = {
      ...filters,
      page: options.page || 1,
      limit: options.limit || 20
    };
    const response = await api.get('/partners/payouts', { params });
    return response.data;
  },


  /**
   * Request payout
   */
  async requestPayout(notes = '') {
    const response = await api.post('/partners/payouts/request', { notes });
    return response.data;
  },

  /**
   * Get payout by ID
   */
  async getPayoutById(id) {
    const response = await api.get(`/partners/payouts/${id}`);
    return response.data;
  },

  /**
   * Format currency
   */
  formatCurrency(amount, currency = 'USD') {
    const formatted = Number(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return `${formatted} ${currency === 'USD' ? 'US$' : currency}`;
  },

  /**
   * Get status color
   */
  getStatusColor(status) {
    const colors = {
      pending: 'warning',
      approved: 'info',
      paid: 'success',
      rejected: 'error',
      processing: 'info',
      completed: 'success',
      failed: 'error'
    };
    return colors[status] || 'default';
  },

  /**
   * Get status label
   */
  getStatusLabel(status) {
    const labels = {
      pending: 'Pendiente',
      approved: 'Aprobada',
      paid: 'Pagada',
      rejected: 'Rechazada',
      processing: 'Procesando',
      completed: 'Completado',
      failed: 'Fallido'
    };
    return labels[status] || status;
  }
};

export default commissionService;
